import styles from './styles.module.scss';
import { Breadcrumbs, Flex, Title, UnstyledButton, Space } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { ChevronDown, ChevronUp } from '@geist-ui/icons';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {  updateCurrent } from 'src/store';
import { useAlert,useFormFocus } from '@common/hooks';
import { useForm, yupResolver } from '@mantine/form';
import * as yup from 'yup';
import { validationPattern } from '@common/helpers';
import {  Button, Checkbox, Divider, Modal, Popover, Select, TextInput, PasswordInput } from '@common/components';
import { shallowEqual } from 'react-redux';
import { useDisclosure } from '@mantine/hooks';
import classNames from 'classnames';
import { useMediaQuery } from '@mantine/hooks';


function ManageUsers() {
    const navigate = useNavigate();
    const { companyId } = useParams();
    const [t] = useTranslation('account');
    const [c] = useTranslation('common');
    const [opened, { open, close }] = useDisclosure(false);
    const isMobile = useMediaQuery('(max-width: 768px)');

    const [expandedRows, setExpandedRows] = useState<string[]>([]);
    const [companyUsers, setCompanyUsers] = useState([
        { id: '1', name: 'Michael Holz', email: 'michael@email.com', date: '04/10/2013', role: 'Admin', status: 'active', img: '' },
        { id: '2', name: 'Paula Wilson', email: 'paula@email.com', date: '05/08/2014', role: 'Siteowner', status: 'active', img: '' },
        { id: '3', name: 'Antonio Moreno', email: 'antonio@email.com', date: '11/05/2015', role: 'Publisher', status: 'suspended', img: '' },
        { id: '4', name: 'Mary Saveley', email: 'mary@email.com', date: '06/09/2016', role: 'Reviewer', status: 'active', img: '' },
        { id: '5', name: 'Martin Sommer', email: 'martin@email.com', date: '12/08/2017', role: 'Moderator', status: 'inactive', img: '' },
    ]);
    const { showAlert } = useAlert();
    const { data } = useAppSelector((state) => state.user, shallowEqual);
    const getStatusDot = (status :any) => {
        switch (status) {
            case 'active':
                return <span className={styles.statusDot} style={{ backgroundColor: 'green' }}></span>;
            case 'suspended':
                return <span className={styles.statusDot} style={{ backgroundColor: 'red' }}></span>;
            case 'inactive':
                return <span className={styles.statusDot} style={{ backgroundColor: 'orange' }}></span>;
            default:
                return null;
        }
    };

    const getInitials = (name:any ) => {
        return name ? name.split(' ').map((n:any) => n[0]).join('').slice(0, 2).toUpperCase() : '';
    };
        
    const initialValues: Record<string, string> = {
        firstName: '',
        lastName: '',
      };

    const form = useForm({
        initialValues: initialValues,
        validate: (values) => {
        
        const verify  =  yupResolver(validationFormSchema)
        const result = verify(values)
        //   console.log( result  );
          if ( Object.keys(result).length > 0  ) {
            setNeedFocus(true)
          }else {
            setNeedFocus(false)
          }
          return result
        } 
      });
    const { setNeedFocus } = useFormFocus({ formErrors: form.errors });
    const toggleRow = (id: string) => {
        if (expandedRows.includes(id)) {
            setExpandedRows(expandedRows.filter(rowId => rowId !== id));
        } else {
            setExpandedRows([...expandedRows, id]);
        }
    };
    const dispatch = useAppDispatch();

    const onSubmitHandler = async (values: Record<string, string>): Promise<void> => {
        dispatch(updateCurrent({ data: values, successMessage: successMessage }));
      };

    const successMessage = (): void => {
    showAlert({
        id: 'GeneralInfo',
        title: c('Success'),
        message: `${t('generalInfoSuccess')}`,
        variant: 'success',
    });
    };

    const validationFormSchema = yup.object().shape({
    firstName: validationPattern.firstName,
    lastName: validationPattern.lastName,
    });

  const [isLoading, setIsLoading] = useState<boolean>(false);
//   const onSubmitHandler = async (values: Record<string, string>): Promise<void> => {
//     setIsLoading(true);
//     setNeedFocus(true);
//     try {
//       const user = await Auth.currentAuthenticatedUser({
//         bypassCache: true,
//       });
//       await Auth.changePassword(user, values.oldPassword, values.password);
//       showAlert({
//         id: 'PassSucces',
//         title: c('Success'),
//         message: `${t('passwordInfoSuccess')}`,
//         variant: 'success',
//       });
//     } catch (error: any) {
//       if (error.code === 'NotAuthorizedException') {
//         showAlert({
//           id: error.message,
//           title: c('Error'),
//           message: `${t('notAuthorizedException')}`,
//           variant: 'error',
//         });
//       } else if (error instanceof Error) {
//         showAlert({
//           id: error.message,
//           title: c('Error'),
//           message: error.message,
//           variant: 'error',
//         });
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

    return (
        <div style={{ width: '100%', flex: '1', padding: '3rem',backgroundColor: '#f6fafa' }}>
            <div className={styles.wrapper}>
                <Breadcrumbs separator="/" mt="xs">
                    <Link to={"#"} style={{color:"black"}}>{t('Companies')}</Link>
                    <Link to={"#"} style={{color:"black"}}>{t('List of users')}</Link>
                </Breadcrumbs>
                <Flex justify={"space-between"} p={"sm"} pl={0} mt={"20px"}>
                    <Title className={styles['second-heading']} mb={'18px'} order={1}>
                        List Of Users
                    </Title>
                </Flex>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th></th>
                            <th className={styles.flex}>Name <ChevronDown/></th>
                            <th className={styles.flex}>Role <ChevronDown/></th>
                            <th className={styles.flex}>Status <ChevronDown/></th>
                        </tr>
                    </thead>
                    <tbody>
                        {companyUsers.map((user, index) => (
                            <React.Fragment key={user.id}>
                                <tr>
                                    <td onClick={() => toggleRow(user.id)}>
                                        <div>
                                            <UnstyledButton className={styles.circelBorder} style={ expandedRows.includes(user.id)? {backgroundColor:"#5b5eff",color:"white"}: undefined } aria-label={`Click here for more settings about 
                                                ${user?.name}`} >
                                                {expandedRows.includes(user.id) ? <ChevronUp/> : <ChevronDown />}
                                            </UnstyledButton>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={styles.userInfo}>

                                            {
                                                !isMobile && (user.img ? (
                                                    <img src={user.img} alt={`${user.name}`} className={styles.userImage} />
                                                ) : (
                                                    <div className={styles.initialsCircle}>
                                                        {getInitials(user.name)}
                                                    </div>
                                                ))

                                            }


                                            {user.name}
                                        </div>
                                    </td>
                                    <td>{user.role}</td>
                                    <td>{getStatusDot(user.status)} { !isMobile && user.status.charAt(0).toUpperCase() + user.status.slice(1) }</td>
                                </tr>
                                {expandedRows.includes(user.id) && (
                                    <tr className={styles.expandedRow}>
                                        <td colSpan={4}>
                                            <div className={styles.settings}>
                                                <strong style={{marginBottom:"15px",display:"block"}}>Settings for {user.name}</strong>
                                                
                                                <div className={styles['right-content']}>
                                                    {/* <Title className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
                                                    {t('nav.accountDetails')}
                                                    </Title> */}
                                                    {/* <p>{t('nav.accountDesrption')}</p> */}
                                                    <form
                                                        className={`${styles['general-info']}  roleForm` }
                                                        onSubmit={form.onSubmit((values) => {
                                                        onSubmitHandler(values);
                                                        setNeedFocus(true);
                                                    })}>
                                                    {/* <Select
                                                    className={styles['dropdown-role']}
                                                    variant="primary"
                                                    withIcon
                                                    aria-label={`${c('combobox')}`}
                                                    value={userRole}
                                                    label={`${t('nav.role')}` }
                                                    data={rolesList}
                                                    onChange={(e) => { setUserRole(e  || "")  }}
                                                    />
                                                    <Space h={'md'} /> */}
                                                    <TextInput
                                                    autoComplete={'given-name'}
                                                    label={`${t('firstName')}`}
                                                    withAsterisk={true}
                                                    placeholder={`${t('firstNamePlaceholder')}`}
                                                    // {...form.getInputProps('firstName')}
                                                    value={user.name}
                                                    />
                                                    <Space h={'md'} />
                                                    <TextInput
                                                    autoComplete={'family-name'}
                                                    withAsterisk={true}
                                                    label={`${t('lastName')}`}
                                                    placeholder={`${t('lastNamePlaceholder')}`}
                                                    // {...form.getInputProps('lastName')}
                                                    value={user.name}

                                                    />
                                                    {/* <Space h={'md'} /> */}
                                                    {/* <Flex direction={'column'} mb={'8px'}>
                                                    <span className={styles['info-label']}>{t('email')}</span>
                                                    {data.email}
                                                    </Flex> */}
                                                    <Space h={'md'} />
                                                    <TextInput
                                                    disabled
                                                    type='email'
                                                    label={`${t('nav.email')}`}
                                                    placeholder={`Your Email`}
                                                    {...form.getInputProps('email')}
                                                    // value={data.email}
                                                    value={user.email}

                                                    />
                                                    <Space h={'md'} />
                                                    <Checkbox
                                                        className={styles.notifyCheckbox}
                                                        label="Send Email Notification When Audit Start or Complete"
                                                        checked={true}
                                                        // onChecked={(e) => setNotifications(e.target.checked)}
                                                    />
                                                    <Flex  gap={'md'}>
                                                    <Button onClick={() => form.clearErrors() }  className={styles['form-btn']} type={'submit'}>
                                                    {t('updateInformation')}
                                                    </Button>
                                                    <Button 
                                                        color='gray'
                                                        ariaLabel='Undo changes made'
                                                        className={styles['form-btn']} 
                                                        onClick={ () => {
                                                        form.setValues({ firstName: data.firstName, lastName: data.lastName });
                                                        form.clearErrors();
                                                        }}
                                                        >
                                                    { t('nav.undoAccount')}
                                                    </Button>

                                                    </Flex>

                                                    </form>
                                                    {/* <div > */}
                                                        <form
                                                            style={{ marginLeft:"50px" }}
                                                            className={styles['password-info']}
                                                            onSubmit={form.onSubmit((values) => {
                                                            onSubmitHandler(values);
                                                            setNeedFocus(true);
                                                            })}>
                                                            <PasswordInput
                                                            withAsterisk={true}
                                                            label={t('oldPassword')}
                                                            placeholder={t('oldPasswordPlaceholder')}
                                                            {...form.getInputProps('oldPassword')}
                                                            />
                                                            <Space h={'md'} />
                                                            <PasswordInput
                                                            withAsterisk={true}
                                                            label={`${t('newPassword')}`}
                                                            placeholder={`${t('newPasswordPlacholder')}`}
                                                            {...form.getInputProps('password')}
                                                            />
                                                            <Space h={'md'} />
                                                            <PasswordInput
                                                            withAsterisk={true}
                                                            label={`${t('confirmPassword')}`}
                                                            placeholder={`${t('confirmPasswordPlacholder')}`}
                                                            {...form.getInputProps('confirmPassword')}
                                                            />
                                                            <Space h={'md'} />
                                                            <Button onClick={ ( ) => form.clearErrors() }  className={styles['form-btn']} type={'submit'} loading={isLoading}>
                                                            {t('changePassword')}
                                                            </Button>
                                                        </form>
                                                    {/* </div> */}
                                                    </div>
                                                    <Space h={'md'} />
                                                    <Link to={"javascript:;"} className={styles.deleteAccount} onClick={open}> Delete User </Link>
                                                    <Link to={"javascript:;"} className={classNames(styles.deleteAccount, styles.deactivateAccount)} style={{marginLeft:"20px"}} > Deactivate User </Link>

                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ManageUsers;
